<template>
    <div style="padding-top: 88px" v-if="ksitem">
        <div class="hrjoin-compy">
            <div class="title">申请企业</div>
            <div class="compy-info flex">
                <div class="logo">
                    <img :src="logourl">
                </div>
                <div>
                  <div class="flex info-item">
                      <div class="compy-ft">公司名称:</div>
                      <div class="compy-tx">{{ksitem.ksname}}</div>
                  </div>
                  <div class="flex info-item">
                      <div class="compy-ft">公司地址:</div>
                      <div class="compy-tx">{{ksitem.kscity}}</div>
                  </div>
                  <div class="flex info-item">
                      <div class="compy-ft">负责人:</div>
                      <div class="compy-tx">{{ksitem.ksadname}}</div>
                  </div>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="label">验证信息</div>
            <el-input
            class="com-input value"
            placeholder="请输入验证消息"
            v-model="applyRemark">
            </el-input>
        </div>
        <div class="item">
            <div class="label"></div>
            <div class="value">
                <div class="primary-btn" @click="join" >提交申请</div>
            </div>
        </div>
        <!-- <button style="margin-top:40px;" @click="join" class="btn-primary">下一步</button>
        <button style="margin-top:20px;" @click="goback" class="btn-primary btn-default">返回上一步</button> -->
    </div>
</template>
<script>
const qs = require("qs");
export default {
  data() {
    return {
      ksitem: {},
      nickName: "",
      headImage: "",
      applyRemark: "",
      compyinfo: null,
      showUploadMask: false
    };
  },
  computed: {
    logourl() {
      if (this.ksitem.kslogo) {
        if (this.ksitem.kslogo.indexOf("http") > -1) {
          return this.ksitem.kslogo;
        } else {
          return "//oss.51ztx.com/" + this.ksitem.kslogo;
        }
      }
    }
  },
  created() {
    let id = this.$route.query.id;
    this.axios.get("/wapi/company/getJoin?companyId=" + id).then(res => {
      if (res.data) {
        this.ksitem = {
          ksid: res.data.id,
          kslogo: res.data.logo,
          ksname: res.data.name,
          ksadname: res.data.adminName,
          ksadminPhone: res.data.adminPhone,
          kscity:
            res.data.provinceName +
            res.data.cityName +
            res.data.areaName +
            res.data.streetName +
            res.data.address
        };
      }
    });
  },
  methods: {
    //模拟hover效果   鼠标放在头像显示上传按钮
    overShow() {
      this.showUploadMask = !this.showUploadMask;
    },
    outHide() {
      this.showUploadMask = !this.showUploadMask;
    },
    //end
    goback() {
      this.$router.back();
    },
    getInfo(id) {
      let url = `/wapi/company/get?companyId=${id}`;
      this.axios.get(url).then(res => {
        this.compyinfo = res.data;
      });
    },
    faceChange(event) {
      let formdata = new FormData();
      formdata.append("headImageFile", event.target.files[0]);
      this.axios.post("/wapi/base/upload/headImage", formdata).then(res => {
        if (res.status * 1 == 200) {
          this.headImage = res.data;
        }
      });
    },
    join() {
      let qdata = {
        companyId: this.ksitem.ksid,
        // nickName: this.nickName,
        // headImage: this.headImage,
        applyRemark: this.applyRemark
      };
      if (this.headImage.length == 0) {
      }
      let url = `/wapi/hr/joinCompany`;
      this.axios.post(url, qs.stringify(qdata)).then(res => {
        if (res.success) {
          this.$router.push({
            path: "/register/regsuc",
            query: {
              kscompyname: encodeURI(this.ksitem.ksname),
              ksadname: encodeURI(this.ksitem.ksadname),
              ksadminPhone: encodeURI(this.ksitem.ksadminPhone)
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/reglogin.less');
.hrjoin-compy{
  width: 536px;
  // height: 184px;
  box-sizing: border-box;
  background: #EAF4FF;
  border-radius: 8px;
  margin-bottom: 54px;
  padding: 20px 30px 36px;
  .title{
    font-size: 20px;
    color: #333333;
    margin-bottom: 20px;
    text-align: center;
  }
  .logo{
    width: 80px;
    height: 80px;
    margin-right: 60px;
    flex-shrink: 0;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .info-item{
    line-height: 28px;
    color: #333333;
    font-size: 16px;
    align-items: flex-start;
  }
  .compy-ft{
    flex-shrink: 0;
    width: 70px;
    text-align: right;
    margin-right: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// hrapply.vue?31584e5c